import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  if (!isLoaded) return <div style={{ color: 'white', padding: '2rem' }}>Loading...</div>;
  if (!isSignedIn) return <Navigate to="/sign-in" />;
  return children;
}